import type {
  Application,
  ApplicationCreateInput,
  ApplicationSummary,
  BulkApplicationInput,
  BulkApplicationResult,
} from "@app/shared";
import { api, qs } from "../../lib/api";

interface Paged<T> {
  items: T[];
  total: number;
  page: number;
  limit: number;
}

export const applicationsApi = {
  list: (params: { status?: string; page?: number } = {}) =>
    api.get<Paged<Application>>(`/applications${qs({ ...params })}`),
  summary: () => api.get<ApplicationSummary>("/applications/summary"),
  bulk: (input: BulkApplicationInput) =>
    api.post<BulkApplicationResult>("/applications/bulk", input),
  create: (input: ApplicationCreateInput) => api.post<Application>("/applications", input),
  approve: (id: string) => api.post<Application>(`/applications/${id}/approve`),
  reject: (id: string, reason?: string) =>
    api.post<Application>(`/applications/${id}/reject`, { reason }),
  cancel: (id: string, reason?: string) =>
    api.post<Application>(`/applications/${id}/cancel`, { reason }),
  renotify: (id: string) => api.post<Application>(`/applications/${id}/renotify`),
};
